import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 11.4977V13.9977H4.5L11.8733 6.62439L9.37333 4.12439L2 11.4977ZM13.8067 4.69106C13.8685 4.62938 13.9175 4.55612 13.951 4.47547C13.9844 4.39482 14.0016 4.30837 14.0016 4.22106C14.0016 4.13374 13.9844 4.04729 13.951 3.96664C13.9175 3.88599 13.8685 3.81273 13.8067 3.75106L12.2467 2.19106C12.185 2.12925 12.1117 2.08022 12.0311 2.04677C11.9504 2.01331 11.864 1.99609 11.7767 1.99609C11.6894 1.99609 11.6029 2.01331 11.5223 2.04677C11.4416 2.08022 11.3683 2.12925 11.3067 2.19106L10.0867 3.41106L12.5867 5.91106L13.8067 4.69106Z",
		fill: "currentColor"
	})
});
export default SvgEditIcon;
